// Version : 0.0.1
// Author : Vignesh
// LastEdit : Vignesh
// Last Add : 'Added Comment Lines'
// Modified Date : 22-09-2025
import { call, put, takeLatest } from 'redux-saga/effects';
import { encryptData } from '../../_common/enode-decode';
import AlertManager from '../../../utils/alertManager';
import { all } from 'redux-saga/effects';
import CashTransactionTypes from './common-transaction.types';
import {
	// ADD CASH TRANSACTION DETAILS RESPONSE
	addCashTransactionDetailsFailure,
	addCashTransactionDetailsResponseChanged,
	addCashTransactionDetailsSuccess,
	// DELETE CASH TRANSACTION DETAILS RESPONSE
	deleteCashTransactionDetailsFailure,
	deleteCashTransactionDetailsResponseChanged,
	deleteCashTransactionDetailsSuccess,
	// GET ACCOUNT DAY BOOK RESPONSE
	getAccountDayBookListFailure,
	getAccountDayBookListResponseChanged,
	getAccountDayBookListSuccess,
	// GET CASH TRANSACTION RESPONSE
	getCashTransactionListFailure,
	getCashTransactionListResponseChanged,
	getCashTransactionListSuccess,
	// GET VOUCHER COUNT BASED ON COMPANY RESPONSE
	getVoucherCountBasedOnCompanyFailure,
	getVoucherCountBasedOnCompanySuccess,
	getVoucherCountBasedOnCompanyResponseChanged,
	// CHECK BRANCH EOD DONE RESPONSE
	checkBranchEODDoneFailure,
	checkBranchEODDoneSuccess,
	checkBranchEODDoneResponseChanged,
	// GET COMPANY FINANCE ACCOUNT TYPE LIST RESPONSE
	getCompanyFinanceAccountTypeListFailure,
	getCompanyFinanceAccountTypeListResponseChanged,
	getCompanyFinanceAccountTypeListSuccess,
	// GET PARTICULAR CASH TRANSACTION LIST RESPONSE
	getParticularCashTransactionListSuccess,
	getParticularCashTransactionListFailure,
	getParticularCashTransactionListResponseChanged,
	// GET VALUES MODAL RESPONSE
	getValuesModalSuccess,
	getValuesModalFailure,
	getValuesModalResponseChanged,
	// UPDATE CASH TRANSACTION RESPONSE
	updateCashTransactionDetailsSuccess,
	updateCashTransactionDetailsFailure,
	updateCashTransactionDetailsResponseChanged,
	// GET ACCOUNT DAY BOOK FOR ACCOUNT RESPONSE
	getAccountDayBookForAccountFailure,
	getAccountDayBookForAccountSuccess,
	getAccountDayBookForAccountResponseChanged,
	// UPDATE SELECTED TRANSACTION IS APPROVE RESPONSE
	updateSelectedTransactionIsApproveFailure,
	updateSelectedTransactionIsApproveSuccess,
	updateSelectedTransactionIsApproveResponseChanged,
} from './common-transaction.action';
import {
	// GET ACCOUNT DAY BOOK
	accountDayBookGet,
	// UPDATE CASH TRANSACTION
	cashTransactionApproveUpdate,
	// ADD CASH TRANSACTION
	cashTransactionCreate,
	// DELETE CASH TRANSACTION DETAILS
	cashTransactionDelete,
	// GET CASH TRANSACTION
	cashTransactionListGet,
	// UPDATE CASH TRANSACTION
	cashTransactionUpdate,
	// CHECK BRANCH EOD DONE
	checkBranchEODDoneService,
	// GET COMPANY FINANCE ACCOUNT TYPE LIST
	companyFinanceAccountTypeListGet,
	// GET ACCOUNT DAY BOOK
	getAccountDayBookForAccounts,
	// GET PARTICULAR CASH TRANSACTION LIST
	getParticularCashTransactionListService,
	// GET VALUES MODAL
	getValuesModalService,
	// GET VOUCHER COUNT BASED ON COMPANY
	getVoucherCountBasedCompany,
} from './common-transaction.service';

/** ***************** ADD GROUP ACCOUNT DETAILS START *********************** */
export function* addCashTransactionDetails({ payload }: any) {
	try {
		const key = 'CreateTranscationEntryKey';
		const {
			infogCompanyID,
			accountID,
			entryDate,
			transactiontype,
			totalAmount,
			transactionArr,
			userID,
			branchID,
			databaseName,
			userName,
			transactionImage,
			toBranchID,
		} = payload;

		const jsonData = {
			InfogCompanyID: infogCompanyID,
			AccountID: accountID,
			EntryDate: entryDate,
			TransactionType: transactiontype,
			TotalAmount: totalAmount,
			TranscationArr: transactionArr,
			CreatedBy: userID,
			CreatedFor: branchID,
			ToBranchID: toBranchID,
			IsLoanCollection: '0',
			DatabaseName: databaseName,
			UserName: userName,
			ModifiedBy: userID,
			TransactionImage: transactionImage,
		};

		const encodeData = encryptData(jsonData, key);
		//@ts-ignore
		const responseData = yield call(cashTransactionCreate, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(addCashTransactionDetailsFailure(responseData.data));
		} else {
			yield put(addCashTransactionDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(addCashTransactionDetailsFailure(error));
	}
}

export function* resetAddCashTransactionDetailsResponse() {
	yield put(addCashTransactionDetailsResponseChanged());
}

export function* onAddCashtransactionDetails() {
	yield takeLatest(
		CashTransactionTypes.ADD_CASH_TRANSACTION_DETAILS_START,
		addCashTransactionDetails,
	);
}

export function* onAddCashTransactionDetailsResponseReset() {
	yield takeLatest(
		CashTransactionTypes.ADD_CASH_TRANSACTION_DETAILS_RESPONSE_RESET,
		resetAddCashTransactionDetailsResponse,
	);
}
/** ***************** ADD GROUP ACCOUNT DETAILS END *********************** */

/** ***************** UPDATE GROUP ACCOUNT DETAILS START *********************** */
export function* updateCashTransactionDetails({ payload }: any) {
	try {
		const key = 'UpdateCashTransactionKey';
		const {
			infogCompanyID,
			accountID,
			entryDate,
			transactiontype,
			totalAmount,
			transactionArr,
			userID,
			branchID,
			databaseName,
			userName,
			transactionID,
			transactionImage,
			toBranchID,
			isLoanCollection,
		} = payload;

		const jsonData = {
			InfogCompanyID: infogCompanyID,
			AccountID: accountID,
			EntryDate: entryDate,
			TransactionType: transactiontype,
			TotalAmount: totalAmount,
			TranscationArr: transactionArr,
			CreatedBy: userID,
			CreatedFor: branchID,
			ToBranchID: toBranchID,
			IsLoanCollection: isLoanCollection,
			DatabaseName: databaseName,
			UserName: userName,
			ModifiedBy: userID,
			TransactionID: transactionID,
			TransactionImage: transactionImage,
		};

		const encodeData = encryptData(jsonData, key);
		//@ts-ignore
		const responseData = yield call(cashTransactionUpdate, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateCashTransactionDetailsFailure(responseData.data));
		} else {
			yield put(updateCashTransactionDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateCashTransactionDetailsFailure(error));
	}
}
export function* resetUpdateCashTransactionDetailsResponse() {
	yield put(updateCashTransactionDetailsResponseChanged());
}
export function* onUpdateCashTransactionDetails() {
	yield takeLatest(
		CashTransactionTypes.UPDATE_CASH_TRANSACTION_DETAILS_START,
		updateCashTransactionDetails,
	);
}
export function* onUpdateCashTransactionDetailsResponseReset() {
	yield takeLatest(
		CashTransactionTypes.UPDATE_CASH_TRANSACTION_DETAILS_RESPONSE_RESET,
		resetUpdateCashTransactionDetailsResponse,
	);
}
/** ***************** UPDATE GROUP ACCOUNT DETAILS END *********************** */
export function* getCashTransactionList({ payload }: any) {
	try {
		const key = 'GetCompanyTranscationEntryListKey';
		const {
			infogCompanyID,
			userLevel,
			databaseName,
			transactionType,
			limit,
			userID,
			branchID,
			inputSearch,
			searchType,
			transactionApproveStatus,
			type,
			fromDate,
			toDate,
		} = payload;

		const jsonData = {
			InfogCompanyID: infogCompanyID,
			UserLevel: userLevel,
			DatabaseName: databaseName,
			TranscationType: transactionType,
			Limit: limit,
			CreatedBy: userID,
			CreatedFor: branchID,
			InputSearch: inputSearch,
			SearchType: searchType,
			BranchID: branchID,
			TransactionApproveStatus: transactionApproveStatus,
			Type: type,
			FromDate: fromDate,
			ToDate: toDate,
		};

		const encodeData = encryptData(jsonData, key);
		//@ts-ignore
		const responseData = yield call(cashTransactionListGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getCashTransactionListFailure(responseData.data));
		} else {
			yield put(getCashTransactionListSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getCashTransactionListFailure(error));
	}
}
export function* resetGetCashTransactionListResponse() {
	yield put(getCashTransactionListResponseChanged());
}
export function* onGetCashTransactionList() {
	yield takeLatest(CashTransactionTypes.GET_CASH_TRANSACTION_LIST_START, getCashTransactionList);
}
export function* onGetCashTransactionListResponseReset() {
	yield takeLatest(
		CashTransactionTypes.GET_CASH_TRANSACTION_LIST_RESPONSE_RESET,
		resetGetCashTransactionListResponse,
	);
}

/** ***************** DELETE CASH TRANSACTION DETAILS START *********************** */
export function* deleteCashTransactionDetails({ payload }: any) {
	try {
		const key = 'DeleteCashTransactionKey';
		const {
			infogCompanyID,
			userID,
			transactionID,
			databaseName,
			accountID,
			userName,
			transactionType,
			branchID,
		} = payload;

		const jsonData = {
			InfogID: infogCompanyID,
			UserID: userID,
			TransactionID: transactionID,
			DatabaseName: databaseName,
			AccountID: accountID,
			UserName: userName,
			TransactionType: transactionType,
			BranchID: branchID,
		};

		const encodeData = encryptData(jsonData, key);
		//@ts-ignore
		const responseData = yield call(cashTransactionDelete, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(deleteCashTransactionDetailsFailure(responseData.data));
		} else {
			yield put(deleteCashTransactionDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(deleteCashTransactionDetailsFailure(error));
	}
}
export function* resetDeleteCashTransactionDetailsResponse() {
	yield put(deleteCashTransactionDetailsResponseChanged());
}
export function* onDeleteCashTransactionDetails() {
	yield takeLatest(
		CashTransactionTypes.DELETE_CASH_TRANSACTION_DETAILS_START,
		deleteCashTransactionDetails,
	);
}
export function* onDeleteCashTransactionDetailsResponseReset() {
	yield takeLatest(
		CashTransactionTypes.DELETE_CASH_TRANSACTION_DETAILS_RESPONSE_RESET,
		resetDeleteCashTransactionDetailsResponse,
	);
}
/** ***************** DELETE CASH TRANSACTION DETAILS END *********************** */

/** ***************** GET COMPANY FINANCE ACCOUNT TYPE LIST START *********************** */
export function* getCompanyFinanceAccountTypeList({ payload }: any) {
	try {
		const key = 'FetchCompanyFinanceAccountTypeListKey';
		const { infogCompanyID, databaseName, userID, branchID, viewUser, companyID, type } =
			payload;

		const jsonData = {
			InfogID: infogCompanyID,
			DatabaseName: databaseName,
			UserID: userID,
			UserAccessBranchID: branchID,
			ViewUser: viewUser,
			CompanyID: companyID,
			Type: type,
		};

		const encodeData = encryptData(jsonData, key);
		//@ts-ignore
		const responseData = yield call(companyFinanceAccountTypeListGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getCompanyFinanceAccountTypeListFailure(responseData.data));
		} else {
			yield put(getCompanyFinanceAccountTypeListSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getCompanyFinanceAccountTypeListFailure(error));
	}
}

export function* resetGetCompanyFinanceAccountTypeListResponse() {
	yield put(getCompanyFinanceAccountTypeListResponseChanged());
}

export function* onGetCompanyFinanceAccountTypeList() {
	yield takeLatest(
		CashTransactionTypes.GET_COMPANY_FINANCE_ACCOUNT_TYPE_LIST_START,
		getCompanyFinanceAccountTypeList,
	);
}

export function* onGetCompanyFinanceAccountTypeListResponseReset() {
	yield takeLatest(
		CashTransactionTypes.GET_COMPANY_FINANCE_ACCOUNT_TYPE_LIST_RESPONSE_RESET,
		resetGetCompanyFinanceAccountTypeListResponse,
	);
}
/** ***************** GET COMPANY FINANCE ACCOUNT TYPE LIST END *********************** */

/** ***************** GET ACCOUNT DAY BOOK LIST START *********************** */

export function* getAccountDayBookList({ payload }: any) {
	try {
		const key = 'getExistAccountDayBookKey';
		const {
			databaseName,
			entryDate,
			fromDate,
			toDate,
			transactionType,
			branchID,
			accountHeadID,
			infog_CompanyID,
			searchbyDateType,
			companyID,
		} = payload;

		const jsonData = {
			DatabaseName: databaseName,
			EntryDate: entryDate,
			FromDate: fromDate,
			ToDate: toDate,
			AccountType: transactionType,
			BranchID: branchID,
			AccountHeadID: accountHeadID,
			Infog_CompanyID: infog_CompanyID,
			SearchbyDateType: searchbyDateType,
			CompanyID: companyID,
		};

		const encodeData = encryptData(jsonData, key);
		//@ts-ignore
		const responseData = yield call(accountDayBookGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getAccountDayBookListFailure(responseData.data));
		} else {
			yield put(getAccountDayBookListSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getAccountDayBookListFailure(error));
	}
}

export function* resetGetAccountDayBookListResponse() {
	yield put(getAccountDayBookListResponseChanged());
}

export function* onGetAccountDayBookListList() {
	yield takeLatest(CashTransactionTypes.GET_ACCOUNT_DAY_BOOK_LIST_START, getAccountDayBookList);
}

export function* onGetAccountDayBookListResponseReset() {
	yield takeLatest(
		CashTransactionTypes.GET_ACCOUNT_DAY_BOOK_LIST_RESPONSE_RESET,
		resetGetAccountDayBookListResponse,
	);
}

/** ***************** GET ACCOUNT DAY BOOK LIST END *********************** */

/** ***************** VOUCHER COUNT BASED ON COMPANY START *********************** */
export function* getVoucherCountBasedOnCompany({ payload }: any) {
	try {
		const key = 'GetCompanyVoucherCountBasedOnCompanyKey';
		const { infogCompanyID, companyID, databaseName, type, branchID, entryDate } = payload;

		const jsonData = {
			InfogCompanyID: infogCompanyID,
			CompanyID: companyID,
			DatabaseName: databaseName,
			TransactionType: type,
			CreatedFor: branchID,
			EntryDate: entryDate,
		};

		const encodeData = encryptData(jsonData, key);
		//@ts-ignore
		const responseData = yield call(getVoucherCountBasedCompany, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getVoucherCountBasedOnCompanyFailure(responseData.data));
		} else {
			yield put(getVoucherCountBasedOnCompanySuccess(responseData.data));
		}
	} catch (error) {
		yield put(getVoucherCountBasedOnCompanyFailure(error));
	}
}

export function* resetVoucherCountResponse() {
	yield put(getVoucherCountBasedOnCompanyResponseChanged());
}

export function* onGetVoucherCountBasedOnCompany() {
	yield takeLatest(
		CashTransactionTypes.GET_VOUCHER_COUNT_BASED_ON_COMPANY_START,
		getVoucherCountBasedOnCompany,
	);
}

export function* onGetVoucherCountBasedOnCompanyResponseReset() {
	yield takeLatest(
		CashTransactionTypes.GET_VOUCHER_COUNT_BASED_ON_COMPANY_RESPONSE_RESET,
		resetVoucherCountResponse,
	);
}
/** ***************** VOUCHER COUNT BASED ON COMPANY END *********************** */

/** *****************CHECK BRANCH EOD DONE START *********************** */
export function* checkBranchEODDone({ payload }: any) {
	try {
		const key = 'GetParticularBranchEODListKey';
		const { companyID, branchID, userID, databaseName, date } = payload;

		const jsonData = {
			CompanyID: companyID,
			FromBranchID: branchID,
			UserID: userID,
			DatabaseName: databaseName,
			EODDate: date,
		};

		const encodeData = encryptData(jsonData, key);
		//@ts-ignore
		const responseData = yield call(checkBranchEODDoneService, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(checkBranchEODDoneFailure(responseData.data));
		} else {
			yield put(checkBranchEODDoneSuccess(responseData.data));
		}
	} catch (error) {
		yield put(checkBranchEODDoneFailure(error));
	}
}

export function* resetCheckBranchEODDoneResponse() {
	yield put(checkBranchEODDoneResponseChanged());
}

export function* onCheckBranchEODDone() {
	yield takeLatest(CashTransactionTypes.CHECK_BRANCH_EOD_DONE_START, checkBranchEODDone);
}

export function* onCheckBranchEODDoneResponseReset() {
	yield takeLatest(
		CashTransactionTypes.CHECK_BRANCH_EOD_DONE_RESPONSE_RESET,
		resetCheckBranchEODDoneResponse,
	);
}
/** *****************CHECK BRANCH EOD DONE END *********************** */

/** *****************GET PARTICULAR CASH TRANSACTION LIST START *********************** */

export function* getParticularCashTransactionList({ payload }: any) {
	try {
		const key = 'particulerBranchAccountKey';
		const { infogCompanyID, branchID, accountType, databaseName } = payload;

		const jsonData = {
			InfogID: infogCompanyID,
			BranchID: branchID,
			accountNameForVoucher: accountType,
			DatabaseName: databaseName,
		};

		const encodeData = encryptData(jsonData, key);
		//@ts-ignore
		const responseData = yield call(getParticularCashTransactionListService, encodeData);

		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getParticularCashTransactionListFailure(responseData.data));
		} else {
			yield put(getParticularCashTransactionListSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getParticularCashTransactionListFailure(error));
	}
}

// Response Reset saga (optional, as per your conventions)
export function* resetGetParticularCashTransactionListResponse() {
	yield put(getParticularCashTransactionListResponseChanged());
}

export function* onGetParticularCashTransactionList() {
	yield takeLatest(
		CashTransactionTypes.GET_PARTICULAR_CASH_TRANSACTION_LIST_START,
		getParticularCashTransactionList,
	);
}

export function* onGetParticularCashTransactionListResponseReset() {
	yield takeLatest(
		CashTransactionTypes.GET_PARTICULAR_CASH_TRANSACTION_LIST_RESPONSE_RESET,
		resetGetParticularCashTransactionListResponse,
	);
}
/** *****************GET PARTICULAR CASH TRANSACTION LIST END *********************** */

/** *****************UPDATE SELECTED TRANSACTION IS APPROVE START *********************** */

export function* updateSelectedTransactionIsApprove({ payload }: any) {
	try {
		const key = 'ApprovalUpdateCashTransactionKey';

		const {
			databaseName,
			rejectNotes,
			transactionID,
			isStatus,
			userID,
			userName,
			transactionType,
		} = payload;

		const jsonData = {
			DatabaseName: databaseName,
			RejectNotes: rejectNotes,
			transactionID: transactionID,
			isStatus: isStatus,
			MemberApprovedBy: userID,
			UserName: userName,
			TransactionType: transactionType,
		};

		const encodeData = encryptData(jsonData, key);

		//@ts-ignore
		const responseData = yield call(cashTransactionApproveUpdate, encodeData);

		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateSelectedTransactionIsApproveFailure(responseData.data));
		} else {
			yield put(updateSelectedTransactionIsApproveSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateSelectedTransactionIsApproveFailure(error));
	}
}

export function* resetUpdateSelectedTransactionIsApproveResponse() {
	yield put(updateSelectedTransactionIsApproveResponseChanged());
}

export function* onUpdateSelectedTransactionIsApprove() {
	yield takeLatest(
		CashTransactionTypes.UPDATE_SELECTED_TRANSACTION_IS_APPROVE_START,
		updateSelectedTransactionIsApprove,
	);
}

export function* onUpdateSelectedTransactionIsApproveResponseReset() {
	yield takeLatest(
		CashTransactionTypes.UPDATE_SELECTED_TRANSACTION_IS_APPROVE_RESPONSE_RESET,
		resetUpdateSelectedTransactionIsApproveResponse,
	);
}
/** *****************UPDATE SELECTED TRANSACTION IS APPROVE END *********************** */

/** *****************GET VALUES MODAL START *********************** */

export function* getValuesModal({ payload }: any) {
	try {
		const key = 'GetModalValuesKey';
		const { databaseName, branchID, companyID, fromAccountID, transactionID, transactionType } =
			payload;

		const jsonData = {
			DatabaseName: databaseName,
			BranchID: branchID,
			CompanyID: companyID,
			FromAccountID: fromAccountID,
			TransactionID: transactionID,
			TransactionType: transactionType,
		};

		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(getValuesModalService, encodeData);

		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getValuesModalFailure(responseData.data));
		} else {
			yield put(getValuesModalSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getValuesModalFailure(error));
	}
}

export function* resetValuesModalResponse() {
	yield put(getValuesModalResponseChanged());
}

export function* onGetValuesModal() {
	yield takeLatest(CashTransactionTypes.GET_VALUES_MODAL_START, getValuesModal);
}

export function* onGetValuesModalResponseReset() {
	yield takeLatest(
		CashTransactionTypes.GET_VALUES_MODAL_RESPONSE_RESET,
		resetValuesModalResponse,
	);
}

/** *****************GET VALUES MODAL END *********************** */

/** ***************** GET ACCOUNT DAY BOOK FOR ACCOUNT START *********************** */
export function* getAccountDayBookForAccount({ payload }: any) {
	try {
		const key = 'getExistAccountDayBookForAccountKey';
		const {
			databaseName,
			entryDate,
			fromDate,
			toDate,
			accountType,
			branchID,
			accountHeadID,
			infog_CompanyID,
			searchbyDateType,
			companyID,
		} = payload;

		const jsonData = {
			DatabaseName: databaseName,
			EntryDate: entryDate,
			FromDate: fromDate,
			ToDate: toDate,
			AccountType: accountType,
			BranchID: branchID,
			AccountHeadID: accountHeadID,
			Infog_CompanyID: infog_CompanyID,
			SearchbyDateType: searchbyDateType,
			CompanyID: companyID,
		};

		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(getAccountDayBookForAccounts, encodeData);

		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getAccountDayBookForAccountFailure(responseData.data));
		} else {
			yield put(getAccountDayBookForAccountSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getAccountDayBookForAccountFailure(error));
	}
}

export function* resetGetAccountDayBookForAccountResponse() {
	yield put(getAccountDayBookForAccountResponseChanged());
}

export function* onGetAccountDayBookForAccount() {
	yield takeLatest(
		CashTransactionTypes.GET_ACCOUNT_DAY_BOOK_FOR_ACCOUNT_START,
		getAccountDayBookForAccount,
	);
}

export function* onGetAccountDayBookForAccountResponseReset() {
	yield takeLatest(
		CashTransactionTypes.GET_ACCOUNT_DAY_BOOK_FOR_ACCOUNT_RESPONSE_RESET,
		resetGetAccountDayBookForAccountResponse,
	);
}
/** ***************** GET ACCOUNT DAY BOOK FOR ACCOUNT END *********************** */

export default function* CashTransactionSaga() {
	yield all([
		// ADD CASH TRANSACTION DETAILS RESPONSE
		call(onAddCashtransactionDetails),
		call(onAddCashTransactionDetailsResponseReset),
		// UPDATE CASH TRANSACTION RESPONSE
		call(onUpdateCashTransactionDetails),
		call(onUpdateCashTransactionDetailsResponseReset),
		// GET CASH TRANSACTION RESPONSE
		call(onGetCashTransactionList),
		call(onGetCashTransactionListResponseReset),
		// DELETE CASH TRANSACTION DETAILS RESPONSE
		call(onDeleteCashTransactionDetails),
		call(onDeleteCashTransactionDetailsResponseReset),
		// GET COMPANY FINANCE ACCOUNT TYPE LIST RESPONSE
		call(onGetCompanyFinanceAccountTypeList),
		call(onGetCompanyFinanceAccountTypeListResponseReset),
		// GET ACCOUNT DAY BOOK RESPONSE
		call(onGetAccountDayBookListList),
		call(onGetAccountDayBookListResponseReset),
		// GET VOUCHER COUNT BASED ON COMPANY RESPONSE
		call(onGetVoucherCountBasedOnCompany),
		call(onGetVoucherCountBasedOnCompanyResponseReset),
		// CHECK BRANCH EOD DONE RESPONSE
		call(onCheckBranchEODDone),
		call(onCheckBranchEODDoneResponseReset),
		// GET PARTICULAR CASH TRANSACTION LIST RESPONSE
		call(onGetParticularCashTransactionList),
		call(onGetParticularCashTransactionListResponseReset),
		// UPDATE SELECTED TRANSACTION IS APPROVE RESPONSE
		call(onUpdateSelectedTransactionIsApprove),
		call(onUpdateSelectedTransactionIsApproveResponseReset),
		// GET VALUES MODAL RESPONSE
		call(onGetValuesModal),
		call(onGetValuesModalResponseReset),
		// GET ACCOUNT DAY BOOK FOR ACCOUNT RESPONSE
		call(onGetAccountDayBookForAccount),
		call(onGetAccountDayBookForAccountResponseReset),
	]);
}
